import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { PlannedCourse } from '../../../../../global/builders/planned_course_builder';
import { APPlannedCourseServant } from '../../../../../global/servants/ap_planned_course_servant';
import { DEEMPHASIZE_DROP_AREA, EMPHASIZE_DROP_AREA } from '../../../../../plan/constants/event_names';

class DegreeMapSlotGroupComponentController {
  private groupExpanded: boolean = false;
  private isEditable: boolean | string;
  private dropGenericSlots = []; // SGD-10826
  constructor(private ngComponentCommunicatorService: CommunicatorService) {}
  shouldOpenCourseGroup($event: any, groupExpanded: boolean) {
    // current target will be the li tag as we attached the event on it.
    // target will be the element click happened
    // we don't want to close the course group when click happened on course tile element
    const event = $event.currentTarget.querySelector('.course-group-tile-collapse-handler');
    const clickedOnTrigger: boolean = event
      ? $event.currentTarget.querySelector('.course-group-tile-collapse-handler').contains($event.target)
      : false;
    if (groupExpanded && clickedOnTrigger) {
      return false;
    }
    return true;
  }
  emphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(EMPHASIZE_DROP_AREA);
  }
  deEmphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(DEEMPHASIZE_DROP_AREA);
  }
  $onChanges() {
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
  }

  getStatusBadgeForPlannedCourse(plannedCourse: PlannedCourse) {
    return APPlannedCourseServant.statusBadge(plannedCourse);
  }
}

class DegreeMapSlotGroupComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      slots: '=',
      isEditable: '<?'
    };
    this.controller = DegreeMapSlotGroupComponentController;
    this.templateUrl =
      'capability-ng-academic-planner/src/plan/components/degree_map/components/degree_map_slot_group_component/degree_map_slot_group_component.html';
  }
}
angular
  .module('capability-ng-academic-planner')
  .component('degreeMapSlotGroupComponent', new DegreeMapSlotGroupComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/degree_map/components/degree_map_slot_group_component/degree_map_slot_group_component.ts